import { useEffect, useState } from 'react';
import { debounce } from '../';

export const useIsBelowWidth = (
  widthBreakpoint: number,
  delay: number = 200,
): boolean | undefined => {
  const [width, setWidth] = useState<number>();

  useEffect(() => {
    const handleWindowSizeChange = () => {
      setWidth(window.innerWidth);
    };
    handleWindowSizeChange();
    window.addEventListener(
      'resize',
      debounce<typeof handleWindowSizeChange>(handleWindowSizeChange, delay),
    );
    return () => {
      window.removeEventListener(
        'resize',
        debounce<typeof handleWindowSizeChange>(handleWindowSizeChange, delay),
      );
    };
  }, []);

  if (width === undefined) return undefined;

  return width <= widthBreakpoint;
};
